import styles from "./mapIcons.module.scss";

interface IconProps {
  size?: "tiny" | "small" | "medium" | "large" | "huge";
  className?: string;
}

const sizeClasses = {
  tiny: styles.sizeTiny,
  small: styles.sizeSmall,
  medium: styles.sizeMedium,
  large: styles.sizeLarge,
  huge: styles.sizeHuge
};

interface IconWrapperProps extends IconProps {
  children: React.ReactNode;
  viewBox: string;
}

function IconWrapper({ size = "medium", className, children, viewBox }: IconWrapperProps) {
  return (
    <div className={`${styles.iconWrapper} ${sizeClasses[size]}${className ? ` ${className}` : ""}`}>
      <svg viewBox={viewBox} fill="currentColor" xmlns="http://www.w3.org/2000/svg" className={styles.svg}>
        {children}
      </svg>
    </div>
  );
}

export function GeoIcon({ size = "medium", className }: IconProps) {
  return (
    <IconWrapper size={size} className={className} viewBox="0 0 24 24">
      <path d="M23.5889 5.8423C25.2377 2.379 21.6223 -1.23778 18.1575 0.411028L2.32277 7.95152C-0.923241 9.4971 -0.722232 14.1841 2.64464 15.4458L6.36465 16.8407C6.54611 16.9087 6.71089 17.0149 6.84793 17.1519C6.98497 17.2889 7.0911 17.4538 7.15917 17.6352L8.554 21.3566C9.81708 24.722 14.5027 24.9231 16.0483 21.6771L23.5889 5.8423Z" />
    </IconWrapper>
  );
}

export function MenuIcon({ size = "medium", className }: IconProps) {
  return (
    <IconWrapper size={size} className={className} viewBox="0 0 24 18">
      <path d="M6 0H1.5C0.671573 0 0 0.671573 0 1.5C0 2.32843 0.671573 3 1.5 3H6C6.82843 3 7.5 2.32843 7.5 1.5C7.5 0.671573 6.82843 0 6 0Z" />
      <path d="M22.5 15H18C17.1716 15 16.5 15.6716 16.5 16.5C16.5 17.3284 17.1716 18 18 18H22.5C23.3284 18 24 17.3284 24 16.5C24 15.6716 23.3284 15 22.5 15Z" />
      <path d="M22.5 0H12C11.1716 0 10.5 0.671573 10.5 1.5C10.5 2.32843 11.1716 3 12 3H22.5C23.3284 3 24 2.32843 24 1.5C24 0.671573 23.3284 0 22.5 0Z" />
      <path d="M12 15H1.5C0.671573 15 0 15.6716 0 16.5C0 17.3284 0.671573 18 1.5 18H12C12.8284 18 13.5 17.3284 13.5 16.5C13.5 15.6716 12.8284 15 12 15Z" />
      <path d="M22.5 7.5H1.5C0.671573 7.5 0 8.17157 0 9C0 9.82843 0.671573 10.5 1.5 10.5H22.5C23.3284 10.5 24 9.82843 24 9C24 8.17157 23.3284 7.5 22.5 7.5Z" />
    </IconWrapper>
  );
}

export function SupportIcon({ size = "medium", className }: IconProps) {
  return (
    <IconWrapper size={size} className={className} viewBox="0 0 24 22">
      <path d="M10.8 22V19.5556H20.4V10.8778C20.4 8.49444 19.5852 6.47289 17.9556 4.81311C16.326 3.15333 14.3408 2.32304 12 2.32222C9.65916 2.3214 7.6744 3.15171 6.0456 4.81311C4.4168 6.47451 3.6016 8.49607 3.6 10.8778V18.3333H0V11.3361H1.2L1.29 9.71667C1.45 8.33148 1.8452 7.04815 2.4756 5.86667C3.106 4.68518 3.896 3.65649 4.8456 2.78056C5.7952 1.90463 6.8848 1.22222 8.1144 0.733333C9.344 0.244444 10.6392 0 12 0C13.3608 0 14.6508 0.244444 15.87 0.733333C17.0892 1.22222 18.1792 1.89974 19.14 2.76589C20.1008 3.63204 20.8908 4.65544 21.51 5.83611C22.1292 7.01678 22.5292 8.30011 22.71 9.68611L22.8 11.3361H24V18.3333H22.8V22H10.8ZM8.4 13.4444C8.06 13.4444 7.7752 13.3271 7.5456 13.0924C7.316 12.8578 7.2008 12.5677 7.2 12.2222C7.1992 11.8767 7.3144 11.5867 7.5456 11.352C7.7768 11.1173 8.0616 11 8.4 11C8.7384 11 9.0236 11.1173 9.2556 11.352C9.4876 11.5867 9.6024 11.8767 9.6 12.2222C9.5976 12.5677 9.4824 12.8581 9.2544 13.0937C9.0264 13.3292 8.7416 13.446 8.4 13.4444ZM15.6 13.4444C15.26 13.4444 14.9752 13.3271 14.7456 13.0924C14.516 12.8578 14.4008 12.5677 14.4 12.2222C14.3992 11.8767 14.5144 11.5867 14.7456 11.352C14.9768 11.1173 15.2616 11 15.6 11C15.9384 11 16.2236 11.1173 16.4556 11.352C16.6876 11.5867 16.8024 11.8767 16.8 12.2222C16.7976 12.5677 16.6824 12.8581 16.4544 13.0937C16.2264 13.3292 15.9416 13.446 15.6 13.4444ZM4.83 11.55C4.69 9.3907 5.33 7.53704 6.75 5.98889C8.17 4.44074 9.93996 3.66667 12.06 3.66667C13.84 3.66667 15.4052 4.24193 16.7556 5.39244C18.106 6.54296 18.9208 8.01533 19.2 9.80956C17.38 9.78841 15.7052 9.28889 14.1756 8.31111C12.646 7.33333 11.4708 6.00926 10.65 4.33889C10.33 5.96851 9.6552 7.42011 8.6256 8.69367C7.596 9.96722 6.3308 10.9193 4.83 11.55Z" />
    </IconWrapper>
  );
}
